import type { ChangeIntentMarkInput, ChangeVerdictView, ChangeWindow, ChangeWindowInput } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

/** Change windows (#26): planned work Detect suppresses during and verifies after.
 *  Windows are immutable (create/delete only); verdicts are read-only records. */
export const changeService = {
  list: (
    tenantId: string,
    params: { limit?: number; startAfter?: string; deleted?: boolean } = {}
  ): Promise<PaginatedResult<WithId<ChangeWindow>>> =>
    api.getPaginated<WithId<ChangeWindow>>(withTenant('/changes/windows', tenantId, {
        limit: params.limit,
        startAfter: params.startAfter,
        ...(params.deleted ? { deleted: 'true' } : {}),
      })),
  create: (tenantId: string, input: ChangeWindowInput): Promise<WithId<ChangeWindow>> =>
    api.post<WithId<ChangeWindow>>(withTenant('/changes/windows', tenantId), input),
  remove: (tenantId: string, id: string): Promise<void> =>
    api.delete(withTenant(`/changes/windows/${id}`, tenantId)),
  /** A person's mark on an occurrence's intent (rung 3): decides the answer and overrides a machine result. */
  mark: (tenantId: string, id: string, input: ChangeIntentMarkInput): Promise<unknown> =>
    api.post<unknown>(withTenant(`/changes/windows/${id}/intent-marks`, tenantId), input),
  verdicts: (tenantId: string, id: string): Promise<ChangeVerdictView[]> =>
    api.get<ChangeVerdictView[]>(withTenant(`/changes/windows/${id}/verdicts`, tenantId)),
};
